import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatSort,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material";

@Component({
  selector: 'app-post-trip-points-breakup',
  templateUrl: './post-trip-points-breakup.component.html',
  styleUrls: ['./post-trip-points-breakup.component.css']
})
export class PostTripPointsBreakupComponent implements OnInit {

  public displayedColumns = [
      "tripCode",
      "descriptions",
      "points",
      "pointsValue",
    ];
    public dataSource = new MatTableDataSource<ItineraryEntity>();
    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;
    @ViewChild(MatSort, { static: true })
    sort: MatSort;
    response: any = {};
    model = {};
    destination: string = "";
    constructor(
      public dialogRef: MatDialogRef<PostTripPointsBreakupComponent>,
      @Inject(MAT_DIALOG_DATA) public data
    ) {}
    ngOnInit() {
       console.log(this.data);
      //this.destination = this.data.destination;
      this.dataSource.data = this.data.pointList as ItineraryEntity[];
    }
    ngAfterViewInit() {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    onCloseClick(): void {
      this.dialogRef.close();
    }
  }
  export interface ItineraryEntity {
    TripWhsDefaultId:number;
    tripCode: string;
    descriptions: string;
    pointsValue: string;
    Points:string;
  }
